import cn from 'classnames';
import { useEffect, useState } from 'react';

import { useTextStyle } from '@webapp/common/components/custom-styles';
import { CssPageBlock, CssQuestionType, CssUiComponent } from '@webapp/common/components/survey-custom';
import { setHtml } from '@webapp/common/lib/ui';
import { stringNotEmpty } from '@webapp/common/lib/utils';

import css from './left-right.css';

const Label: FC<{
    style: CSSProperties;
    value: any;
}> = ({ style, value }) => {
    if (!stringNotEmpty(value)) return null;
    return <div className={cn(CssUiComponent.LABEL, css.label)} style={style} {...setHtml(value)} />;
};

export const LeftRight: FC<{
    left: string;
    right: string;
    className: string;
    needToCheckHorizontal?: boolean;
    children?: ReactNode;
}> = ({ children, className, left, right, needToCheckHorizontal = false }) => {
    const { textStyle: labelStyle } = useTextStyle();
    const [ref, setRef] = useState<HTMLDivElement | null>(null);
    const [isLoaded, setLoaded] = useState(!needToCheckHorizontal);
    const [isHorizontal, setHorizontal] = useState(false);

    useEffect(() => {
        if (needToCheckHorizontal && ref) {
            if (ref.clientWidth !== ref.scrollWidth) {
                setHorizontal(true);
            }
            setLoaded(true);
            const handleResize = () => {
                if (ref.clientWidth !== ref.scrollWidth) {
                    setHorizontal(true);
                }
            };
            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }
    }, [needToCheckHorizontal && ref]);

    if (needToCheckHorizontal && isHorizontal) {
        return (
            <div className={cn(className, css.horizontalRoot)}>
                <Label style={labelStyle} value={left} />
                <div className={css.horizontalChildren}>{children}</div>
                <Label style={labelStyle} value={right} />
            </div>
        );
    }

    return (
        <div className={cn(CssQuestionType.QUESTION, css.leftRight, !isLoaded && css.hidden, className)}>
            <div ref={setRef} className={css.wrap}>
                <div className={cn(CssUiComponent.LABEL, css.labels)}>
                    <Label style={labelStyle} value={left} />
                    <Label style={labelStyle} value={right} />
                </div>
                <div className={cn(CssPageBlock.ANSWER, css.content)}>{children}</div>
            </div>
        </div>
    );
};
